import { motion, AnimatePresence } from "framer-motion";
import { LOGO_SRC } from "../../data/menu";
import { APP } from "../../constants/testIds";

export const LoadingScreen = ({ visible }) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid={APP.loading}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.65, 0, 0.35, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0a0906]"
        >
          <div className="absolute inset-0 opacity-[0.08] pointer-events-none noise-texture" />
          <motion.img
            src={LOGO_SRC}
            alt="Los Andariegos"
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="w-56 sm:w-72 md:w-80 max-w-[70vw] select-none"
            draggable={false}
          />
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.1, ease: [0.65, 0, 0.35, 1] }}
            className="absolute bottom-[22vh] h-px w-40 origin-left bg-[#c9a961]/60"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
